import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderService } from './services/loader.service';
import { GlobalLoaderComponent } from './components/misc-component/global-loader.component';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ChatbotWidgetComponent } from './shared/chatbot-widget/chatbot-widget.component';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoaderComponent, AsyncPipe, ChatbotWidgetComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {
  loading$: Observable<boolean> = this.loader.loading$;
  readonly isEmbeddedForm = window.location.pathname.startsWith('/drizzle-form/')
    && new URLSearchParams(window.location.search).get('embed') === '1';

  constructor(private loader: LoaderService) {}
}
